export const config = {

    "300 Srt": {
        "displayname" : "300 SRT",
        "carsize": "SRT",
        "url": "https://assets.fcaab.com.au/assets-public/forms/chrysler/300C-SRT.jpg",
        "alt": "300 SRT",
        "cta": {
            "features": "https://www.chrysler.com.au/300srt.html",
            "offers": "https://www.chrysler.com.au/offers.html",
            "brochure": "https://www.chrysler.com.au/request-a-brochure.html?vehicle=300-srt&year=2018",
            "quote": "https://www.chrysler.com.au/get-a-quote.html?vehicle=300-srt&year=2018",
            "testdrive": "https://www.chrysler.com.au/schedule-a-test-drive.html?vehicle=300-srt&year=2018",
            "specs": "https://mydigimag.rrd.com/publication/?i=577378",
        },
        "year": "2018",
        images : [
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/mobile/portrait/300C-SRT.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/mobile/portrait/300C-SRT.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/mobile/landscape/300C-SRT.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/mobile/landscape/300C-SRT.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/tablet/landscape/300C-SRT.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/tablet/landscape/300C-SRT.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/tablet/portrait/300C-SRT.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/tablet/portrait/300C-SRT.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/desktop/300C-SRT.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/desktop/300C-SRT.jpg 2x"
        ]

    },
    "300C Luxury": {
        "displayname" : "300C Luxury",
        "carsize": "Luxury",
        "url": "https://assets.fcaab.com.au/assets-public/forms/chrysler/300C.jpg",
        "alt": "300C Luxury",
        "cta": {
            "features": "https://www.chrysler.com.au/300c.html",
            "offers": "https://www.chrysler.com.au/offers.html",
            "brochure": "https://www.chrysler.com.au/request-a-brochure.html?vehicle=300c-luxury&year=2018",
            "quote": "https://www.chrysler.com.au/get-a-quote.html?vehicle=vehicle=300c-luxury&year=2018",
            "testdrive": "https://www.chrysler.com.au/schedule-a-test-drive.html?vehicle=vehicle=300c-luxury&year=2018",
            "specs": "https://mydigitalpublication.com/publication/?i=460427",
        },
        "year": "2018",
        images : [
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/mobile/portrait/300C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/mobile/portrait/300C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/mobile/landscape/300C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/mobile/landscape/300C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/tablet/landscape/300C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/tablet/landscape/300C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/tablet/portrait/300C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/tablet/portrait/300C.jpg 2x",
            "https://assets.fcaab.com.au/assets-public/forms/chrysler/1x/desktop/300C.jpg 1x, https://assets.fcaab.com.au/assets-public/forms/chrysler/2x/desktop/300C.jpg 2x"
        ]
    },
    "Pacer": {
        "displayname" : "Pacer",
        "url": "",
        "alt": "Pacer",
        "cta": {
            "features": "",
            "offers": "",
            "brochure": "",
            "quote": "",
            "testdrive": "",
            "specs": "",
        },
        "year": "2019",
        images : [
        ]
    },
    models: [
        '300C Luxury',
        '300 Srt',
    ],

    privacypolicy : "https://www.chrysler.com.au/privacypolicy.html",
    ra : "https://www.chrysler.com.au/owners.html",
    "compPrivacypolicy" : "https://www.chrysler.com.au/privacypolicy.html",
    virtualtestdrivedealers : [
    ],


};
